export const artopicsMapBySubject = {
  "nc_1st_math": [
    {
      slug: "basic-addition",
      title: "Basic Addition",
      gameType: "multipleChoice",
      questions: [
        {
          question: "What is 1 + 1?",
          answers: [
            { text: "2", correct: true },
            { text: "3", correct: false },
            { text: "0", correct: false },
            { text: "1", correct: false }
          ]
        },
      ]
    },
  ],

  "nc_1st_science": [
    {
      "slug": "motion",
      "title": "Motion",
      "gameType": "multipleChoice",
      "placeholderStyle": {
        "backgroundColor": "transparent"
      },
      "placeholderImage": "",
      "questions": [
        {
          "question": "What is motion?",
          "answers": [
            { "text": "When an object changes its position", "correct": true },
            { "text": "When something makes a sound", "correct": false },
            { "text": "When something gets heavier", "correct": false },
            { "text": "When an object stays still", "correct": false }
          ]
        },
        {
          "question": "How can you tell if an object is in motion?",
          "answers": [
            { "text": "Its position keeps changing", "correct": true },
            { "text": "It makes a noise", "correct": false },
            { "text": "It glows in the dark", "correct": false },
            { "text": "It disappears", "correct": false }
          ]
        },
        {
          "question": "In the song, what example is used to explain motion?",
          "answers": [
            { "text": "A car", "correct": true },
            { "text": "A tree", "correct": false },
            { "text": "A ball", "correct": false },
            { "text": "A bike", "correct": false }
          ]
        },
        {
          "question": "What happens when the parked car is moved up 10 feet?",
          "answers": [
            { "text": "Motion has occurred", "correct": true },
            { "text": "The car disappears", "correct": false },
            { "text": "The car changes color", "correct": false },
            { "text": "Nothing changes", "correct": false }
          ]
        },
        {
          "question": "What does continuous change in position mean?",
          "answers": [
            { "text": "The object is in motion", "correct": true },
            { "text": "The object is growing", "correct": false },
            { "text": "The object is melting", "correct": false },
            { "text": "The object is shrinking", "correct": false }
          ]
        }
      ]
    },    
    {
      "slug": "force",
      "title": "Force",
      "gameType": "dragDrop",
      "placeholderStyle": {
        "backgroundColor": "#b2d8ff"
      },
      "placeholderImage": "",
      "questions": [
        {
          "question": "Match the type of force with its description.",
          "options": [
            { "id": "push", "text": "Push", "image": "", "targetText": "Moves an object away", "targetImage": "" },
            { "id": "pull", "text": "Pull", "image": "", "targetText": "Brings an object closer", "targetImage": "" },
            { "id": "stop", "text": "Stop", "image": "", "targetText": "Force can make something stop", "targetImage": "" },
            { "id": "speed", "text": "Speed Change", "image": "", "targetText": "Force can change how fast something moves", "targetImage": "" }
          ]
        },
        {
          "question": "Match force actions with results.",
          "options": [
            { "id": "change_direction", "text": "Change Direction", "image": "", "targetText": "Force turns an object", "targetImage": "" },
            { "id": "change_speed", "text": "Change Speed", "image": "", "targetText": "Force makes an object move faster or slower", "targetImage": "" },
            { "id": "start_motion", "text": "Start Motion", "image": "", "targetText": "Force makes something begin moving", "targetImage": "" },
            { "id": "stop_motion", "text": "Stop Motion", "image": "", "targetText": "Force makes a moving object stop", "targetImage": "" }
          ]
        },
        {
          "question": "Match the force example to what it causes.",
          "options": [
            { "id": "kick_ball", "text": "Kick a ball", "image": "", "targetText": "Pushes the ball away", "targetImage": "" },
            { "id": "pull_rope", "text": "Pull a rope", "image": "", "targetText": "Brings something closer", "targetImage": "" },
            { "id": "brakes_bike", "text": "Use brakes on bike", "image": "", "targetText": "Stops the motion", "targetImage": "" },
            { "id": "run_faster", "text": "Start running faster", "image": "", "targetText": "Changes speed", "targetImage": "" }
          ]
        },
        {
          "question": "Match the motion effect to the force.",
          "options": [
            { "id": "object_moves", "text": "Object Moves", "image": "", "targetText": "Caused by push or pull", "targetImage": "" },
            { "id": "object_stops", "text": "Object Stops", "image": "", "targetText": "Caused by a force", "targetImage": "" },
            { "id": "object_turns", "text": "Object Turns", "image": "", "targetText": "Force changes direction", "targetImage": "" },
            { "id": "object_slows", "text": "Object Slows Down", "image": "", "targetText": "Force reduces speed", "targetImage": "" }
          ]
        },
        {
          "question": "Match the definition to the term.",
          "options": [
            { "id": "force", "text": "Force", "image": "", "targetText": "A push or a pull", "targetImage": "" },
            { "id": "motion", "text": "Motion", "image": "", "targetText": "Change in position", "targetImage": "" },
            { "id": "speed", "text": "Speed", "image": "", "targetText": "How fast something moves", "targetImage": "" },
            { "id": "direction", "text": "Direction", "image": "", "targetText": "The path an object moves", "targetImage": "" }
          ]
        }
      ]
    },
    {
      "slug": "match-the-science-icons",
      "title": "Match the Science Icons",
      "gameType": "matchThree",
      "placeholderStyle": {
        "backgroundColor": "#b2d8ff"
      },
      "placeholderImage": "",
      "questions": [
        {
          "prompt": "Match 3 or more of the same science icons to earn points! Keep playing until you reach 100 points.",
          "tileTypes": ["🧪", "🌍", "🌿", "🔬", "⚗️", "📚"]
        }
      ]
    },
    {
      "slug": "whatdoplantsandanimalsneed",
      "title": "What Do Plants & Animals Need",
      "gameType": "dragDrop",
      "placeholderStyle": {
        "backgroundColor": "#b2d8ff"
      },
      "placeholderImage": "",
      "questions": [
        {
          "question": "Match the animal needs to what they help with.",
          "options": [
            {
              "id": "food",
              "text": "Food",
              "image": "", 
              "targetText": "Gives animals energy to survive",
              "targetImage": ""
            },
            {
              "id": "water",
              "text": "Water",
              "image": "", 
              "targetText": "Keeps the body hydrated",
              "targetImage": ""
            },
            {
              "id": "air",
              "text": "Air",
              "image": "", 
              "targetText": "Used for breathing",
              "targetImage": ""
            },
            {
              "id": "shelter",
              "text": "Shelter",
              "image": "", 
              "targetText": "Provides safety and protection",
              "targetImage": ""
            }
          ]
        },
        {
          "question": "Match the type of animal to its environment.",
          "options": [
            {
              "id": "terrestrial",
              "text": "Terrestrial Animal",
              "image": "",
              "targetText": "Gets oxygen from the air",
              "targetImage": ""
            },
            {
              "id": "aquatic",
              "text": "Aquatic Animal",
              "image": "",
              "targetText": "Gets oxygen from the water",
              "targetImage": ""
            },
            {
              "id": "both",
              "text": "Some animals",
              "image": "",
              "targetText": "Can live in water or on land",
              "targetImage": ""
            },
            {
              "id": "breathe",
              "text": "All animals",
              "image": "",
              "targetText": "Need to breathe air or absorb oxygen",
              "targetImage": ""
            }
          ]
        },
        {
          "question": "Match the plant needs to their function.",
          "options": [
            {
              "id": "sunlight",
              "text": "Sunlight",
              "image": "",
              "targetText": "Helps plants make their food",
              "targetImage": ""
            },
            {
              "id": "water",
              "text": "Water",
              "image": "",
              "targetText": "Soaks into roots to help them grow",
              "targetImage": ""
            },
            {
              "id": "air",
              "text": "Air",
              "image": "",
              "targetText": "Used in photosynthesis",
              "targetImage": ""
            },
            {
              "id": "soil",
              "text": "Soil Nutrients",
              "image": "",
              "targetText": "Provides minerals and support",
              "targetImage": ""
            }
          ]
        },
        {
          "question": "Match the description to the living thing.",
          "options": [
            {
              "id": "plants",
              "text": "Plants",
              "image": "",
              "targetText": "Make their own food with sunlight",
              "targetImage": ""
            },
            {
              "id": "animals",
              "text": "Animals",
              "image": "",
              "targetText": "Eat plants or other animals for food",
              "targetImage": ""
            },
            {
              "id": "aquaticplant",
              "text": "Aquatic Plant",
              "image": "",
              "targetText": "Lives in water and needs light",
              "targetImage": ""
            },
            {
              "id": "terrestrialplant",
              "text": "Terrestrial Plant",
              "image": "",
              "targetText": "Lives in soil and gets sunlight",
              "targetImage": ""
            }
          ]
        },
        {
          "question": "Match the living thing to what it provides.",
          "options": [
            {
              "id": "plantfood",
              "text": "Plants",
              "image": "",
              "targetText": "Provide food for people and animals",
              "targetImage": ""
            },
            {
              "id": "animalshelter",
              "text": "Animals",
              "image": "",
              "targetText": "May provide shelter or protection",
              "targetImage": ""
            },
            {
              "id": "plantshelter",
              "text": "Trees",
              "image": "",
              "targetText": "Can provide shade and shelter",
              "targetImage": ""
            },
            {
              "id": "soilrole",
              "text": "Soil",
              "image": "",
              "targetText": "Supports plant roots with nutrients",
              "targetImage": ""
            }
          ]
        }
      ]
    },
    {
      "slug": "thingsplantsneed",
      "title": "Things Plants Need",
      "gameType": "multipleChoice",
      "questions": [
        {
          "question": "What do plants need to grow tall?",
          "answers": [
            { "text": "Water, air, light, shelter, and space", "correct": true },
            { "text": "Music and moonlight", "correct": false },
            { "text": "Soil and toys", "correct": false },
            { "text": "Plastic and glass", "correct": false }
          ]
        },
        {
          "question": "Why do plants need water?",
          "answers": [
            { "text": "To help their roots and stay alive", "correct": true },
            { "text": "To cool their leaves", "correct": false },
            { "text": "To make noise", "correct": false },
            { "text": "To grow animals", "correct": false }
          ]
        },
        {
          "question": "Where do plants get light from?",
          "answers": [
            { "text": "The sun", "correct": true },
            { "text": "The moon", "correct": false },
            { "text": "Lamps underground", "correct": false },
            { "text": "Other plants", "correct": false }
          ]
        },
        {
          "question": "What helps plants breathe?",
          "answers": [
            { "text": "Air", "correct": true },
            { "text": "Water", "correct": false },
            { "text": "Dirt", "correct": false },
            { "text": "Clouds", "correct": false }
          ]
        },
        {
          "question": "Why is space important for plants?",
          "answers": [
            { "text": "So they can stretch and grow strong", "correct": true },
            { "text": "To stay quiet", "correct": false },
            { "text": "To watch animals", "correct": false },
            { "text": "To roll around", "correct": false }
          ]
        }
      ]
    },
    {
      "slug": "animalsneed",
      "title": "Animals Need",
      "gameType": "dragDrop",
      "placeholderStyle": {
        "backgroundColor": "#b2d8ff"
      },
      "placeholderImage": "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/images%2Fbg-texture-light-blue-1.png?alt=media&token=059bb3e7-21f9-477b-ad74-fdfd02a715cc",
      "questions": [
        {
          "question": "Match the basic needs of animals to their purpose.",
          "options": [
            {
              "id": "food",
              "text": "Food",
              "image": "",
              "targetText": "Gives energy to survive",
              "targetImage": ""
            },
            {
              "id": "water",
              "text": "Water",
              "image": "",
              "targetText": "Helps with hydration and body function",
              "targetImage": ""
            },
            {
              "id": "shelter",
              "text": "Shelter",
              "image": "",
              "targetText": "Provides safety and a place to live",
              "targetImage": ""
            },
            {
              "id": "air",
              "text": "Air",
              "image": "",
              "targetText": "Used for breathing",
              "targetImage": ""
            }
          ]
        },
        {
          "question": "Match the animals to their oxygen source.",
          "options": [
            {
              "id": "terrestrial",
              "text": "Terrestrial Animals",
              "image": "",
              "targetText": "Breathe oxygen from the air",
              "targetImage": ""
            },
            {
              "id": "aquatic",
              "text": "Aquatic Animals",
              "image": "",
              "targetText": "Get oxygen from the water",
              "targetImage": ""
            },
            {
              "id": "humans",
              "text": "Humans",
              "image": "",
              "targetText": "Need air to breathe",
              "targetImage": ""
            },
            {
              "id": "fish",
              "text": "Fish",
              "image": "",
              "targetText": "Use gills to take in oxygen from water",
              "targetImage": ""
            }
          ]
        },
        {
          "question": "Match the description to the need it represents.",
          "options": [
            {
              "id": "sunlight",
              "text": "Sunlight",
              "image": "",
              "targetText": "Needed by some animals to stay warm",
              "targetImage": ""
            },
            {
              "id": "environment",
              "text": "Environment",
              "image": "",
              "targetText": "Impacts how animals survive",
              "targetImage": ""
            },
            {
              "id": "oxygen",
              "text": "Oxygen",
              "image": "",
              "targetText": "Needed by all living things",
              "targetImage": ""
            },
            {
              "id": "movement",
              "text": "Movement",
              "image": "",
              "targetText": "Helps find food and shelter",
              "targetImage": ""
            }
          ]
        },
        {
          "question": "Match what the animals depend on for survival.",
          "options": [
            {
              "id": "plants",
              "text": "Plants",
              "image": "",
              "targetText": "Provide food for many animals",
              "targetImage": ""
            },
            {
              "id": "water",
              "text": "Water",
              "image": "",
              "targetText": "Essential for all life",
              "targetImage": ""
            },
            {
              "id": "air",
              "text": "Air",
              "image": "",
              "targetText": "Used by lungs or gills to survive",
              "targetImage": ""
            },
            {
              "id": "space",
              "text": "Space",
              "image": "",
              "targetText": "Needed to live and grow",
              "targetImage": ""
            }
          ]
        },
        {
          "question": "Match the rhyme from the song to what it teaches.",
          "options": [
            {
              "id": "shelterline",
              "text": "“Food, shelter, and water”",
              "image": "",
              "targetText": "Three basic animal needs",
              "targetImage": ""
            },
            {
              "id": "sunlightline",
              "text": "“Some animals need sunlight”",
              "image": "",
              "targetText": "They use it to stay warm or grow",
              "targetImage": ""
            },
            {
              "id": "environmentline",
              "text": "“Depends on their environment”",
              "image": "",
              "targetText": "Each animal lives where it survives best",
              "targetImage": ""
            },
            {
              "id": "oxygenline",
              "text": "“Oxygen to keep them safe and sound”",
              "image": "",
              "targetText": "Breathing is essential to survive",
              "targetImage": ""
            }
          ]
        }
      ]
    },
    {
      "slug": "plantsandanimalsneedtheirspace",
      "title": "Plants and Animals Need Their Space",
      "gameType": "multipleChoice",
      "questions": [
        {
          "question": "Why do plants and animals need space?",
          "answers": [
            { "text": "To grow and live their life", "correct": true },
            { "text": "To sleep during the day", "correct": false },
            { "text": "To hide from the sun", "correct": false },
            { "text": "To stay in one spot forever", "correct": false }
          ]
        },
        {
          "question": "What does the right temperature help plants and animals do?",
          "answers": [
            { "text": "Feel comfortable and survive", "correct": true },
            { "text": "Sleep all day", "correct": false },
            { "text": "Sing and dance", "correct": false },
            { "text": "Move to colder places", "correct": false }
          ]
        },
        {
          "question": "What do animals need for shelter?",
          "answers": [
            { "text": "Trees, rocks, or safe places", "correct": true },
            { "text": "Plastic homes", "correct": false },
            { "text": "Swimming pools", "correct": false },
            { "text": "Tiny jars", "correct": false }
          ]
        },
        {
          "question": "Why are bees important to plants?",
          "answers": [
            { "text": "They help spread seeds or pollen", "correct": true },
            { "text": "They eat the plants", "correct": false },
            { "text": "They clean the leaves", "correct": false },
            { "text": "They scare away birds", "correct": false }
          ]
        },
        {
          "question": "What do living and nonliving things do in nature?",
          "answers": [
            { "text": "Work together to help life grow", "correct": true },
            { "text": "Fight each other", "correct": false },
            { "text": "Stay separate", "correct": false },
            { "text": "Only plants help animals", "correct": false }
          ]
        }
      ]
    },
    {
      "slug": "pollination",
      "title": "Pollination",
      "gameType": "dragDrop",
      "placeholderStyle": {
        "backgroundColor": "#b2d8ff"
      },
      "placeholderImage": "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/images%2Fbg-texture-light-blue-1.png?alt=media&token=059bb3e7-21f9-477b-ad74-fdfd02a715cc",
      "questions": [
        {
          "question": "Match each word to its meaning.",
          "options": [
            {
              "id": "pollination",
              "text": "Pollination",
              "image": "",
              "targetText": "Moving pollen from one plant to another",
              "targetImage": ""
            },
            {
              "id": "fertilization",
              "text": "Fertilization",
              "image": "",
              "targetText": "Reproduction process after pollination",
              "targetImage": ""
            },
            {
              "id": "reproduction",
              "text": "Reproduction",
              "image": "",
              "targetText": "How plants make more of themselves",
              "targetImage": ""
            },
            {
              "id": "pollen",
              "text": "Pollen",
              "image": "",
              "targetText": "Powder that moves between plants",
              "targetImage": ""
            }
          ]
        },
        {
          "question": "Match the parts of pollination to their role.",
          "options": [
            {
              "id": "bee",
              "text": "Bee",
              "image": "",
              "targetText": "Carries pollen from flower to flower",
              "targetImage": ""
            },
            {
              "id": "flower",
              "text": "Flower",
              "image": "",
              "targetText": "Receives pollen to make seeds",
              "targetImage": ""
            },
            {
              "id": "wind",
              "text": "Wind",
              "image": "",
              "targetText": "Can also move pollen in the air",
              "targetImage": ""
            },
            {
              "id": "seed",
              "text": "Seed",
              "image": "",
              "targetText": "Forms after fertilization",
              "targetImage": ""
            }
          ]
        },
        {
          "question": "Match the statement to the correct process.",
          "options": [
            {
              "id": "pollination_movement",
              "text": "Pollen moves from one plant to another",
              "image": "",
              "targetText": "Pollination",
              "targetImage": ""
            },
            {
              "id": "pollen_joins_egg",
              "text": "Pollen joins with plant egg cell",
              "image": "",
              "targetText": "Fertilization",
              "targetImage": ""
            },
            {
              "id": "new_plant_grows",
              "text": "A new plant begins to grow",
              "image": "",
              "targetText": "Reproduction",
              "targetImage": ""
            },
            {
              "id": "pollen_source",
              "text": "Pollen is made by the flower",
              "image": "",
              "targetText": "Pollen",
              "targetImage": ""
            }
          ]
        },
        {
          "question": "Match the pollination helper to what it does.",
          "options": [
            {
              "id": "butterfly",
              "text": "Butterfly",
              "image": "",
              "targetText": "Carries pollen on its wings",
              "targetImage": ""
            },
            {
              "id": "hummingbird",
              "text": "Hummingbird",
              "image": "",
              "targetText": "Spreads pollen while drinking nectar",
              "targetImage": ""
            },
            {
              "id": "windpollination",
              "text": "Wind",
              "image": "",
              "targetText": "Moves pollen without animals",
              "targetImage": ""
            },
            {
              "id": "beeagain",
              "text": "Bee",
              "image": "",
              "targetText": "Main pollinator in many plants",
              "targetImage": ""
            }
          ]
        },
        {
          "question": "Match the rhyme with what it means.",
          "options": [
            {
              "id": "pollinationline",
              "text": "“Pollination, what’s up?”",
              "image": "",
              "targetText": "Transferring pollen from plant to plant",
              "targetImage": ""
            },
            {
              "id": "fertilizationline",
              "text": "“Fertilization is the process of reproduction”",
              "image": "",
              "targetText": "Joining pollen with the egg to make seeds",
              "targetImage": ""
            },
            {
              "id": "vocabularyline",
              "text": "“My vocabulary”",
              "image": "",
              "targetText": "Learning new science terms",
              "targetImage": ""
            },
            {
              "id": "reproductionline",
              "text": "“Reproduction by pollination”",
              "image": "",
              "targetText": "Plants making more plants through pollination",
              "targetImage": ""
            }
          ]
        }
      ]
    },
    {
      "slug": "environmentalchange",
      "title": "Environmental Change",
      "gameType": "multipleChoice",
      "questions": [
        {
          "question": "What can organisms do to survive in a changing environment?",
          "answers": [
            { "text": "Adapt or move away", "correct": true },
            { "text": "Stay still and wait", "correct": false },
            { "text": "Disappear on purpose", "correct": false },
            { "text": "Hide in the ground forever", "correct": false }
          ]
        },
        {
          "question": "What happens if an organism cannot meet new demands?",
          "answers": [
            { "text": "It may not survive", "correct": true },
            { "text": "It becomes stronger", "correct": false },
            { "text": "It turns into a rock", "correct": false },
            { "text": "It stops growing but stays alive", "correct": false }
          ]
        },
        {
          "question": "What is it called when organisms leave to find a better place?",
          "answers": [
            { "text": "Migration", "correct": true },
            { "text": "Adaptation", "correct": false },
            { "text": "Pollination", "correct": false },
            { "text": "Fertilization", "correct": false }
          ]
        },
        {
          "question": "What is the process that helps stronger organisms survive and reproduce?",
          "answers": [
            { "text": "Natural selection", "correct": true },
            { "text": "Photosynthesis", "correct": false },
            { "text": "Pollution", "correct": false },
            { "text": "Deforestation", "correct": false }
          ]
        },
        {
          "question": "What is it called when a species can no longer survive?",
          "answers": [
            { "text": "Extinction", "correct": true },
            { "text": "Reproduction", "correct": false },
            { "text": "Pollination", "correct": false },
            { "text": "Germination", "correct": false }
          ]
        }
      ]
    },
    {
      "slug": "habitats",
      "title": "Habitats",
      "gameType": "dragDrop",
      "placeholderStyle": {
        "backgroundColor": "#b2d8ff"
      },
      "placeholderImage": "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/images%2Fbg-texture-light-blue-1.png?alt=media&token=059bb3e7-21f9-477b-ad74-fdfd02a715cc",
      "questions": [
        {
          "question": "Match each word to its definition.",
          "options": [
            {
              "id": "habitat",
              "text": "Habitat",
              "image": "",
              "targetText": "The place where a plant or animal lives",
              "targetImage": ""
            },
            {
              "id": "population",
              "text": "Population",
              "image": "",
              "targetText": "A group of the same kind living in one area",
              "targetImage": ""
            },
            {
              "id": "organism",
              "text": "Organism",
              "image": "",
              "targetText": "Any living thing",
              "targetImage": ""
            },
            {
              "id": "ecosystem",
              "text": "Ecosystem",
              "image": "",
              "targetText": "Living and nonliving things working together",
              "targetImage": ""
            }
          ]
        },
        {
          "question": "Match each animal to its habitat.",
          "options": [
            {
              "id": "ants",
              "text": "Ants",
              "image": "",
              "targetText": "Ant farm",
              "targetImage": ""
            },
            {
              "id": "bees",
              "text": "Bees",
              "image": "",
              "targetText": "Beehive",
              "targetImage": ""
            },
            {
              "id": "fish",
              "text": "Fish",
              "image": "",
              "targetText": "Water",
              "targetImage": ""
            },
            {
              "id": "toucan",
              "text": "Toucan",
              "image": "",
              "targetText": "Rainforest",
              "targetImage": ""
            }
          ]
        },
        {
          "question": "Match what a habitat provides.",
          "options": [
            {
              "id": "food",
              "text": "Food",
              "image": "",
              "targetText": "What organisms eat to stay alive",
              "targetImage": ""
            },
            {
              "id": "water",
              "text": "Water",
              "image": "",
              "targetText": "Needed by all organisms to survive",
              "targetImage": ""
            },
            {
              "id": "temperature",
              "text": "Right Temperature",
              "image": "",
              "targetText": "Helps keep organisms healthy",
              "targetImage": ""
            },
            {
              "id": "minerals",
              "text": "Minerals",
              "image": "",
              "targetText": "Support plant growth and soil health",
              "targetImage": ""
            }
          ]
        },
        {
          "question": "Match each group to how they live.",
          "options": [
            {
              "id": "samekind",
              "text": "Same Kind",
              "image": "",
              "targetText": "Members of the same species",
              "targetImage": ""
            },
            {
              "id": "sametime",
              "text": "Same Time",
              "image": "",
              "targetText": "Living in the same place at once",
              "targetImage": ""
            },
            {
              "id": "together",
              "text": "Living Together",
              "image": "",
              "targetText": "Sharing a habitat and resources",
              "targetImage": ""
            },
            {
              "id": "support",
              "text": "Support System",
              "image": "",
              "targetText": "Working as part of the ecosystem",
              "targetImage": ""
            }
          ]
        },
        {
          "question": "Match the rhyme with the meaning.",
          "options": [
            {
              "id": "plantslive",
              "text": "“Habitats are where plants or animals live”",
              "image": "",
              "targetText": "Definition of a habitat",
              "targetImage": ""
            },
            {
              "id": "samekind",
              "text": "“A group of organisms of the same kind”",
              "image": "",
              "targetText": "A population",
              "targetImage": ""
            },
            {
              "id": "suppliesfood",
              "text": "“That habitat supplies food”",
              "image": "",
              "targetText": "Habitats provide food sources",
              "targetImage": ""
            },
            {
              "id": "temperaturejustright",
              "text": "“Water, temperature just right”",
              "image": "",
              "targetText": "Habitats give proper conditions",
              "targetImage": ""
            }
          ]
        }
      ]
    },
    {
      "slug": "niche",
      "title": "Niche",
      "gameType": "multipleChoice",
      "questions": [
        {
          "question": "What is a niche?",
          "answers": [
            { "text": "The role an animal plays in its ecosystem", "correct": true },
            { "text": "The place an animal sleeps", "correct": false },
            { "text": "A type of nest animals build", "correct": false },
            { "text": "The noise an animal makes", "correct": false }
          ]
        },
        {
          "question": "What does a niche include?",
          "answers": [
            { "text": "How an animal gets food and survives", "correct": true },
            { "text": "How fast an animal runs", "correct": false },
            { "text": "How big the animal grows", "correct": false },
            { "text": "The animal’s favorite toy", "correct": false }
          ]
        },
        {
          "question": "How can a niche change?",
          "answers": [
            { "text": "As an animal grows and changes", "correct": true },
            { "text": "Only when it moves", "correct": false },
            { "text": "When it becomes a plant", "correct": false },
            { "text": "It never changes", "correct": false }
          ]
        },
        {
          "question": "Which is an example of a changing niche?",
          "answers": [
            { "text": "A tadpole eating plants, then a frog eating flies", "correct": true },
            { "text": "A fish swimming faster", "correct": false },
            { "text": "A bird flying higher", "correct": false },
            { "text": "A dog barking louder", "correct": false }
          ]
        },
        {
          "question": "Can two organisms have the same niche?",
          "answers": [
            { "text": "No, each has its own role", "correct": true },
            { "text": "Yes, they always share", "correct": false },
            { "text": "Only if they’re the same size", "correct": false },
            { "text": "Only if they live in the same nest", "correct": false }
          ]
        }
      ]
    },
    {
      "slug": "photosynthesis",
      "title": "Photosynthesis",
      "gameType": "dragDrop",
      "placeholderStyle": {
        "backgroundColor": "#b2d8ff"
      },
      "placeholderImage": "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/images%2Fbg-texture-light-blue-1.png?alt=media&token=059bb3e7-21f9-477b-ad74-fdfd02a715cc",
      "questions": [
        {
          "question": "Match the input needed for photosynthesis to its source.",
          "options": [
            {
              "id": "sunlight",
              "text": "Sunlight",
              "image": "",
              "targetText": "Provides the energy to start photosynthesis",
              "targetImage": ""
            },
            {
              "id": "water",
              "text": "Water",
              "image": "",
              "targetText": "Absorbed by roots from the soil",
              "targetImage": ""
            },
            {
              "id": "carbon_dioxide",
              "text": "Carbon Dioxide",
              "image": "",
              "targetText": "Taken from the air by leaves",
              "targetImage": ""
            },
            {
              "id": "chlorophyll",
              "text": "Chlorophyll",
              "image": "",
              "targetText": "Captures sunlight in green leaves",
              "targetImage": ""
            }
          ]
        },
        {
          "question": "Match each process step to what it does.",
          "options": [
            {
              "id": "sun_energy",
              "text": "Sun’s Energy",
              "image": "",
              "targetText": "Splits water into hydrogen and oxygen",
              "targetImage": ""
            },
            {
              "id": "hydrogen",
              "text": "Hydrogen",
              "image": "",
              "targetText": "Combines with carbon dioxide to make food",
              "targetImage": ""
            },
            {
              "id": "oxygen",
              "text": "Oxygen",
              "image": "",
              "targetText": "Released into the air by the plant",
              "targetImage": ""
            },
            {
              "id": "glucose",
              "text": "Food (Glucose)",
              "image": "",
              "targetText": "Used by the plant to grow and stay alive",
              "targetImage": ""
            }
          ]
        },
        {
          "question": "Match the plant part to its role in photosynthesis.",
          "options": [
            {
              "id": "leaf",
              "text": "Leaf",
              "image": "",
              "targetText": "Where most photosynthesis happens",
              "targetImage": ""
            },
            {
              "id": "root",
              "text": "Root",
              "image": "",
              "targetText": "Takes in water from the ground",
              "targetImage": ""
            },
            {
              "id": "stem",
              "text": "Stem",
              "image": "",
              "targetText": "Moves food and water through the plant",
              "targetImage": ""
            },
            {
              "id": "stomata",
              "text": "Stomata",
              "image": "",
              "targetText": "Tiny holes that let in carbon dioxide",
              "targetImage": ""
            }
          ]
        },
        {
          "question": "Match each result of photosynthesis to who it helps.",
          "options": [
            {
              "id": "food_for_plant",
              "text": "Food for the Plant",
              "image": "",
              "targetText": "Helps the plant grow and stay healthy",
              "targetImage": ""
            },
            {
              "id": "oxygen_for_animals",
              "text": "Oxygen for Animals",
              "image": "",
              "targetText": "Used by animals and humans to breathe",
              "targetImage": ""
            },
            {
              "id": "stored_energy",
              "text": "Stored Energy",
              "image": "",
              "targetText": "Kept inside fruits, roots, or seeds",
              "targetImage": ""
            },
            {
              "id": "ecosystem_balance",
              "text": "Ecosystem Balance",
              "image": "",
              "targetText": "Maintains life on Earth for many species",
              "targetImage": ""
            }
          ]
        },
        {
          "question": "Match the rhyme to its meaning.",
          "options": [
            {
              "id": "photosynthesisline",
              "text": "“Photosynthesis is how plants make food”",
              "image": "",
              "targetText": "Plants create energy using sunlight, water, and air",
              "targetImage": ""
            },
            {
              "id": "chlorophyllline",
              "text": "“Chlorophyll takes in the light”",
              "image": "",
              "targetText": "Green part of the leaf that starts the process",
              "targetImage": ""
            },
            {
              "id": "oxygenline",
              "text": "“Oxygen goes into the air”",
              "image": "",
              "targetText": "By-product that humans and animals breathe",
              "targetImage": ""
            },
            {
              "id": "foodcarried",
              "text": "“Food is carried through the plant”",
              "image": "",
              "targetText": "Plant uses energy to grow and function",
              "targetImage": ""
            }
          ]
        }
      ]
    },
    {
      "slug": "nightandday",
      "title": "Night & Day",
      "gameType": "multipleChoice",
      "questions": [
        {
          "question": "What causes day and night?",
          "answers": [
            { "text": "The spinning of the Earth", "correct": true },
            { "text": "The movement of clouds", "correct": false },
            { "text": "The rising moon", "correct": false },
            { "text": "The blinking stars", "correct": false }
          ]
        },
        {
          "question": "How long does it take the Earth to make one full spin?",
          "answers": [
            { "text": "24 hours", "correct": true },
            { "text": "12 hours", "correct": false },
            { "text": "1 week", "correct": false },
            { "text": "30 days", "correct": false }
          ]
        },
        {
          "question": "Why is only half of the Earth lit at a time?",
          "answers": [
            { "text": "The sun only shines on one side", "correct": true },
            { "text": "The other side is broken", "correct": false },
            { "text": "The moon covers the sun", "correct": false },
            { "text": "That side is colder", "correct": false }
          ]
        },
        {
          "question": "What do we call the side facing the sun?",
          "answers": [
            { "text": "Daytime", "correct": true },
            { "text": "Nighttime", "correct": false },
            { "text": "Sun zone", "correct": false },
            { "text": "Heat side", "correct": false }
          ]
        },
        {
          "question": "What do we call the side not facing the sun?",
          "answers": [
            { "text": "Nighttime", "correct": true },
            { "text": "Midday", "correct": false },
            { "text": "Twilight", "correct": false },
            { "text": "Sunrise", "correct": false }
          ]
        }
      ]
    },
    {
      "slug": "themoonandthesky",
      "title": "The Moon and the Sky",
      "gameType": "dragDrop",
      "placeholderStyle": {
        "backgroundColor": "#b2d8ff"
      },
      "placeholderImage": "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/images%2Fbg-texture-light-blue-1.png?alt=media&token=059bb3e7-21f9-477b-ad74-fdfd02a715cc",
      "questions": [
        {
          "question": "Match the object to what we see it do in the sky.",
          "options": [
            {
              "id": "sun",
              "text": "Sun",
              "image": "",
              "targetText": "Lights up the sky during the day",
              "targetImage": ""
            },
            {
              "id": "moon",
              "text": "Moon",
              "image": "",
              "targetText": "Shines in both day and night",
              "targetImage": ""
            },
            {
              "id": "stars",
              "text": "Stars",
              "image": "",
              "targetText": "Twinkle in the night sky",
              "targetImage": ""
            },
            {
              "id": "sky",
              "text": "Sky",
              "image": "",
              "targetText": "Changes from light to dark each day",
              "targetImage": ""
            }
          ]
        },
        {
          "question": "Match each time of day to what we observe.",
          "options": [
            {
              "id": "daytime",
              "text": "Daytime",
              "image": "",
              "targetText": "The sun shines and the sky is bright",
              "targetImage": ""
            },
            {
              "id": "nighttime",
              "text": "Nighttime",
              "image": "",
              "targetText": "The sky is dark and stars appear",
              "targetImage": ""
            },
            {
              "id": "moon_day",
              "text": "Moon (Day)",
              "image": "",
              "targetText": "Sometimes visible during the day",
              "targetImage": ""
            },
            {
              "id": "moon_night",
              "text": "Moon (Night)",
              "image": "",
              "targetText": "Often bright and visible at night",
              "targetImage": ""
            }
          ]
        },
        {
          "question": "Match the moon shape to its appearance.",
          "options": [
            {
              "id": "crescent",
              "text": "Crescent",
              "image": "",
              "targetText": "Looks like a curved slice",
              "targetImage": ""
            },
            {
              "id": "fullmoon",
              "text": "Full Moon",
              "image": "",
              "targetText": "Looks like a big circle",
              "targetImage": ""
            },
            {
              "id": "newmoon",
              "text": "New Moon",
              "image": "",
              "targetText": "Not easily visible in the sky",
              "targetImage": ""
            },
            {
              "id": "halfmoon",
              "text": "Half Moon",
              "image": "",
              "targetText": "Half of the moon is lit up",
              "targetImage": ""
            }
          ]
        },
        {
          "question": "Match each object with a fun fact from the lyrics.",
          "options": [
            {
              "id": "sun_bright",
              "text": "Sun",
              "image": "",
              "targetText": "Shines during the day and warms the air",
              "targetImage": ""
            },
            {
              "id": "moon_special",
              "text": "Moon",
              "image": "",
              "targetText": "Changes shape and shines at night or day",
              "targetImage": ""
            },
            {
              "id": "stars_sparkle",
              "text": "Stars",
              "image": "",
              "targetText": "Twinkle like glowing sparks",
              "targetImage": ""
            },
            {
              "id": "patterns",
              "text": "Sky Patterns",
              "image": "",
              "targetText": "The moon changes its face over time",
              "targetImage": ""
            }
          ]
        },
        {
          "question": "Match the rhyme with its meaning.",
          "options": [
            {
              "id": "daynightline",
              "text": "“Daytime and nighttime, changes all the way”",
              "image": "",
              "targetText": "The sky looks different depending on time",
              "targetImage": ""
            },
            {
              "id": "magicalmoon",
              "text": "“A crescent, a circle, it’s a magical place”",
              "image": "",
              "targetText": "The moon has many shapes we can see",
              "targetImage": ""
            },
            {
              "id": "moonleads",
              "text": "“Patterns to watch, the moon leads the way”",
              "image": "",
              "targetText": "We can learn by watching the moon change",
              "targetImage": ""
            },
            {
              "id": "seethesky",
              "text": "“So look at the sky, both day and night”",
              "image": "",
              "targetText": "We can see the sun, moon, and stars each day",
              "targetImage": ""
            }
          ]
        }
      ]
    },
    {
      "slug": "themoonchanges",
      "title": "The Moon Changes",
      "gameType": "multipleChoice",
      "questions": [
        {
          "question": "What does the moon do every night?",
          "answers": [
            { "text": "It changes shape", "correct": true },
            { "text": "It moves closer to the sun", "correct": false },
            { "text": "It falls from the sky", "correct": false },
            { "text": "It glows different colors", "correct": false }
          ]
        },
        {
          "question": "What is a full moon?",
          "answers": [
            { "text": "When the whole moon is lit up", "correct": true },
            { "text": "When you can’t see the moon", "correct": false },
            { "text": "When the moon has spots", "correct": false },
            { "text": "When it looks like a star", "correct": false }
          ]
        },
        {
          "question": "What happens after the full moon?",
          "answers": [
            { "text": "The moon starts to shrink", "correct": true },
            { "text": "It becomes red", "correct": false },
            { "text": "It disappears forever", "correct": false },
            { "text": "It turns into the sun", "correct": false }
          ]
        },
        {
          "question": "How long does it take the moon to complete its cycle?",
          "answers": [
            { "text": "About four weeks", "correct": true },
            { "text": "One day", "correct": false },
            { "text": "One year", "correct": false },
            { "text": "A few hours", "correct": false }
          ]
        },
        {
          "question": "Why is the moon fun to watch?",
          "answers": [
            { "text": "It changes shapes and has a pattern", "correct": true },
            { "text": "It makes noise", "correct": false },
            { "text": "It moves like a car", "correct": false },
            { "text": "It shines with blinking lights", "correct": false }
          ]
        }
      ]
    },
    {
      "slug": "thesunsdayjourney",
      "title": "The Sun's Day Journey",
      "gameType": "dragDrop",
      "placeholderStyle": {
        "backgroundColor": "#b2d8ff"
      },
      "placeholderImage": "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/images%2Fbg-texture-light-blue-1.png?alt=media&token=059bb3e7-21f9-477b-ad74-fdfd02a715cc",
      "questions": [
        {
          "question": "Match the time of day to the sun’s position.",
          "options": [
            {
              "id": "morning",
              "text": "Morning",
              "image": "",
              "targetText": "The sun rises in the eastern sky",
              "targetImage": ""
            },
            {
              "id": "afternoon",
              "text": "Afternoon",
              "image": "",
              "targetText": "The sun is high in the sky",
              "targetImage": ""
            },
            {
              "id": "evening",
              "text": "Evening",
              "image": "",
              "targetText": "The sun sets and glows orange or red",
              "targetImage": ""
            },
            {
              "id": "night",
              "text": "Night",
              "image": "",
              "targetText": "The sun is no longer visible",
              "targetImage": ""
            }
          ]
        },
        {
          "question": "Match the sun’s effect to what it causes.",
          "options": [
            {
              "id": "sunlight",
              "text": "Sunlight",
              "image": "",
              "targetText": "Makes the sky bright and helps us see",
              "targetImage": ""
            },
            {
              "id": "warm_air",
              "text": "Sun warms the air",
              "image": "",
              "targetText": "Raises temperature during the day",
              "targetImage": ""
            },
            {
              "id": "shadows",
              "text": "Sunlight makes shadows",
              "image": "",
              "targetText": "Shadows change size during the day",
              "targetImage": ""
            },
            {
              "id": "light_path",
              "text": "Sun's light path",
              "image": "",
              "targetText": "Moves from east to west across the sky",
              "targetImage": ""
            }
          ]
        },
        {
          "question": "Match the rhyme to what it teaches.",
          "options": [
            {
              "id": "sunrise",
              "text": "“Rising in the morning, shining all the way”",
              "image": "",
              "targetText": "The sun appears in the east and gives light",
              "targetImage": ""
            },
            {
              "id": "midday",
              "text": "“Way up high, right in the sky”",
              "image": "",
              "targetText": "The sun reaches its highest point at noon",
              "targetImage": ""
            },
            {
              "id": "sunset",
              "text": "“Starts to set, glowing orange and red”",
              "image": "",
              "targetText": "Describes what we see at sunset",
              "targetImage": ""
            },
            {
              "id": "amazing",
              "text": "“The sun is amazing, way up high!”",
              "image": "",
              "targetText": "The sun’s journey helps life on Earth",
              "targetImage": ""
            }
          ]
        },
        {
          "question": "Match the sun with the correct action.",
          "options": [
            {
              "id": "sun_rises",
              "text": "Sun rises",
              "image": "",
              "targetText": "Happens in the morning",
              "targetImage": ""
            },
            {
              "id": "sun_moves",
              "text": "Sun moves through sky",
              "image": "",
              "targetText": "Appears to travel east to west",
              "targetImage": ""
            },
            {
              "id": "sun_sets",
              "text": "Sun sets",
              "image": "",
              "targetText": "Happens in the evening",
              "targetImage": ""
            },
            {
              "id": "sun_gone",
              "text": "Sun goes away",
              "image": "",
              "targetText": "Sky turns dark and night begins",
              "targetImage": ""
            }
          ]
        },
        {
          "question": "Match each sky description to its time of day.",
          "options": [
            {
              "id": "blue_sky",
              "text": "Bright blue sky",
              "image": "",
              "targetText": "Afternoon",
              "targetImage": ""
            },
            {
              "id": "orange_red",
              "text": "Orange or red glow",
              "image": "",
              "targetText": "Evening",
              "targetImage": ""
            },
            {
              "id": "pink_yellow",
              "text": "Pink or yellow clouds",
              "image": "",
              "targetText": "Sunrise",
              "targetImage": ""
            },
            {
              "id": "dark_sky",
              "text": "Dark sky with stars",
              "image": "",
              "targetText": "Night",
              "targetImage": ""
            }
          ]
        }
      ]
    },
    {
      "slug": "earthslayers",
      "title": "Earth’s Layers",
      "gameType": "multipleChoice",
      "questions": [
        {
          "question": "What is the outer layer of the Earth called?",
          "answers": [
            { "text": "The crust", "correct": true },
            { "text": "The mantle", "correct": false },
            { "text": "The outer core", "correct": false },
            { "text": "The ocean", "correct": false }
          ]
        },
        {
          "question": "Which layer is just below the crust?",
          "answers": [
            { "text": "The mantle", "correct": true },
            { "text": "The inner core", "correct": false },
            { "text": "The atmosphere", "correct": false },
            { "text": "The crust again", "correct": false }
          ]
        },
        {
          "question": "What is the mantle made of?",
          "answers": [
            { "text": "Hot, liquid rock", "correct": true },
            { "text": "Cold ice", "correct": false },
            { "text": "Hard metal", "correct": false },
            { "text": "Ocean water", "correct": false }
          ]
        },
        {
          "question": "What are the two parts of the Earth’s core?",
          "answers": [
            { "text": "Inner core and outer core", "correct": true },
            { "text": "Top core and bottom core", "correct": false },
            { "text": "Upper core and lower crust", "correct": false },
            { "text": "Crust and mantle", "correct": false }
          ]
        },
        {
          "question": "Which Earth layer do we live on?",
          "answers": [
            { "text": "The crust", "correct": true },
            { "text": "The mantle", "correct": false },
            { "text": "The inner core", "correct": false },
            { "text": "The outer core", "correct": false }
          ]
        }
      ]
    },
    {
      "slug": "soilsoilwhatcanyoudo",
      "title": "Soil, Soil, What Can You Do?",
      "gameType": "dragDrop",
      "placeholderStyle": {
        "backgroundColor": "#b2d8ff"
      },
      "placeholderImage": "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/images%2Fbg-texture-light-blue-1.png?alt=media&token=059bb3e7-21f9-477b-ad74-fdfd02a715cc",
      "questions": [
        {
          "question": "Match the type of soil to its description.",
          "options": [
            {
              "id": "sandy",
              "text": "Sandy Soil",
              "image": "",
              "targetText": "Loose and dry, water slips through quickly",
              "targetImage": ""
            },
            {
              "id": "clay",
              "text": "Clay Soil",
              "image": "",
              "targetText": "Heavy and sticky, holds water tightly",
              "targetImage": ""
            },
            {
              "id": "loam",
              "text": "Loam",
              "image": "",
              "targetText": "Holds water and air well, best for growing plants",
              "targetImage": ""
            },
            {
              "id": "mixed",
              "text": "Mixed Soil",
              "image": "",
              "targetText": "Blends sandy and clay for healthy roots",
              "targetImage": ""
            }
          ]
        },
        {
          "question": "Match each soil benefit to what it helps.",
          "options": [
            {
              "id": "air",
              "text": "Air",
              "image": "",
              "targetText": "Needed in soil so plant roots can breathe",
              "targetImage": ""
            },
            {
              "id": "water",
              "text": "Water",
              "image": "",
              "targetText": "Held in soil and absorbed by roots",
              "targetImage": ""
            },
            {
              "id": "nutrients",
              "text": "Nutrients",
              "image": "",
              "targetText": "Provide food to help plants grow",
              "targetImage": ""
            },
            {
              "id": "support",
              "text": "Support",
              "image": "",
              "targetText": "Holds the plant in place and helps it stand",
              "targetImage": ""
            }
          ]
        },
        {
          "question": "Match each part of soil to its origin.",
          "options": [
            {
              "id": "organic",
              "text": "Organic Material",
              "image": "",
              "targetText": "Comes from decaying plants and animals",
              "targetImage": ""
            },
            {
              "id": "rock",
              "text": "Broken Rocks",
              "image": "",
              "targetText": "Made from weathered rock pieces",
              "targetImage": ""
            },
            {
              "id": "water_component",
              "text": "Water",
              "image": "",
              "targetText": "Found between soil particles",
              "targetImage": ""
            },
            {
              "id": "air_component",
              "text": "Air",
              "image": "",
              "targetText": "Trapped in spaces between soil grains",
              "targetImage": ""
            }
          ]
        },
        {
          "question": "Match each soil type to a challenge or benefit.",
          "options": [
            {
              "id": "clay_challenge",
              "text": "Clay Soil",
              "image": "",
              "targetText": "Hard for roots to grow due to lack of air",
              "targetImage": ""
            },
            {
              "id": "sandy_challenge",
              "text": "Sandy Soil",
              "image": "",
              "targetText": "Drains too quickly and dries out",
              "targetImage": ""
            },
            {
              "id": "loam_benefit",
              "text": "Loam Soil",
              "image": "",
              "targetText": "Best for growing plants—good balance",
              "targetImage": ""
            },
            {
              "id": "mix_solution",
              "text": "Mixing Soils",
              "image": "",
              "targetText": "Can improve growing conditions",
              "targetImage": ""
            }
          ]
        },
        {
          "question": "Match the lyric with its meaning.",
          "options": [
            {
              "id": "loose_light",
              "text": "“Sandy soil is loose and light”",
              "image": "",
              "targetText": "Describes dry soil with large particles",
              "targetImage": ""
            },
            {
              "id": "sticky_slow",
              "text": "“Clay is heavy, sticky, and slow”",
              "image": "",
              "targetText": "Soil that holds water but lacks air",
              "targetImage": ""
            },
            {
              "id": "loam_is_best",
              "text": "“Loam is perfect, the best of all”",
              "image": "",
              "targetText": "Ideal soil for plant growth",
              "targetImage": ""
            },
            {
              "id": "mix_it_up",
              "text": "“Mix it up, and plants grow there!”",
              "image": "",
              "targetText": "Combining soils improves results",
              "targetImage": ""
            }
          ]
        }
      ]
    },
    {
      "slug": "rocksandminerals",
      "title": "Rocks & Minerals",
      "gameType": "multipleChoice",
      "questions": [
        {
          "question": "What are minerals?",
          "answers": [
            { "text": "Natural solids with a special shape and color", "correct": true },
            { "text": "Man-made shiny items", "correct": false },
            { "text": "Tiny animals in the dirt", "correct": false },
            { "text": "Liquids found underground", "correct": false }
          ]
        },
        {
          "question": "What are rocks made of?",
          "answers": [
            { "text": "One or more minerals", "correct": true },
            { "text": "Water and sand", "correct": false },
            { "text": "Fire and smoke", "correct": false },
            { "text": "Metal and clay only", "correct": false }
          ]
        },
        {
          "question": "Which of these is a use for rocks or minerals?",
          "answers": [
            { "text": "Building houses and roads", "correct": true },
            { "text": "Floating in the air", "correct": false },
            { "text": "Making clouds", "correct": false },
            { "text": "Growing like plants", "correct": false }
          ]
        },
        {
          "question": "How can we describe minerals?",
          "answers": [
            { "text": "By their color, shape, and how they shine", "correct": true },
            { "text": "By the way they bark or meow", "correct": false },
            { "text": "By their smell and taste", "correct": false },
            { "text": "By the way they grow leaves", "correct": false }
          ]
        },
        {
          "question": "What makes rocks different from each other?",
          "answers": [
            { "text": "The minerals they are made from", "correct": true },
            { "text": "The animals inside them", "correct": false },
            { "text": "The noise they make", "correct": false },
            { "text": "How fast they move", "correct": false }
          ]
        }
      ]
    },
    {
      "slug": "ncstateminerals",
      "title": "NC State Minerals",
      "gameType": "multipleChoice",
      "questions": [
        {
          "question": "What is North Carolina’s state mineral?",
          "answers": [
            { "text": "Gold", "correct": true },
            { "text": "Coal", "correct": false },
            { "text": "Silver", "correct": false },
            { "text": "Iron", "correct": false }
          ]
        },
        {
          "question": "Why is gold important to North Carolina?",
          "answers": [
            { "text": "Gold was first discovered in the U.S. here", "correct": true },
            { "text": "People build houses with gold", "correct": false },
            { "text": "Gold is used to power trains", "correct": false },
            { "text": "It grows on trees", "correct": false }
          ]
        },
        {
          "question": "What is North Carolina’s state rock?",
          "answers": [
            { "text": "Granite", "correct": true },
            { "text": "Marble", "correct": false },
            { "text": "Sandstone", "correct": false },
            { "text": "Limestone", "correct": false }
          ]
        },
        {
          "question": "What is granite mostly used for?",
          "answers": [
            { "text": "Building things like countertops and statues", "correct": true },
            { "text": "Making paper and books", "correct": false },
            { "text": "Fuel for cars", "correct": false },
            { "text": "Writing letters", "correct": false }
          ]
        },
        {
          "question": "What do gold and granite have in common?",
          "answers": [
            { "text": "They are both natural resources found in North Carolina", "correct": true },
            { "text": "They both float in water", "correct": false },
            { "text": "They are made of paper", "correct": false },
            { "text": "They grow from seeds", "correct": false }
          ]
        }
      ]
    },
    {
      "slug": "soil",
      "title": "Soil",
      "gameType": "dragDrop",
      "placeholderStyle": {
        "backgroundColor": "#b2d8ff"
      },
      "placeholderImage": "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/images%2Fbg-texture-light-blue-1.png?alt=media&token=059bb3e7-21f9-477b-ad74-fdfd02a715cc",
      "questions": [
        {
          "question": "Match the soil layer with what it’s made of.",
          "options": [
            {
              "id": "topsoil",
              "text": "Topsoil",
              "image": "",
              "targetText": "Rich with organic material and nutrients",
              "targetImage": ""
            },
            {
              "id": "subsoil",
              "text": "Subsoil",
              "image": "",
              "targetText": "Contains more clay and less organic matter",
              "targetImage": ""
            },
            {
              "id": "bedrock",
              "text": "Bedrock",
              "image": "",
              "targetText": "Solid rock layer deep beneath the soil",
              "targetImage": ""
            },
            {
              "id": "humus",
              "text": "Humus",
              "image": "",
              "targetText": "Decomposed plants and animals",
              "targetImage": ""
            }
          ]
        },
        {
          "question": "Match the soil part to its function.",
          "options": [
            {
              "id": "air_pockets",
              "text": "Air Pockets",
              "image": "",
              "targetText": "Let roots breathe",
              "targetImage": ""
            },
            {
              "id": "water",
              "text": "Water",
              "image": "",
              "targetText": "Helps plants grow by carrying nutrients",
              "targetImage": ""
            },
            {
              "id": "minerals",
              "text": "Minerals",
              "image": "",
              "targetText": "Feed plants with important nutrients",
              "targetImage": ""
            },
            {
              "id": "organic_material",
              "text": "Organic Material",
              "image": "",
              "targetText": "Adds nutrients as it breaks down",
              "targetImage": ""
            }
          ]
        },
        {
          "question": "Match the cause to the way it changes soil.",
          "options": [
            {
              "id": "rain",
              "text": "Rain",
              "image": "",
              "targetText": "Washes nutrients away",
              "targetImage": ""
            },
            {
              "id": "earthworms",
              "text": "Earthworms",
              "image": "",
              "targetText": "Mix and loosen soil",
              "targetImage": ""
            },
            {
              "id": "roots",
              "text": "Plant Roots",
              "image": "",
              "targetText": "Hold soil in place and prevent erosion",
              "targetImage": ""
            },
            {
              "id": "decay",
              "text": "Dead Plants and Animals",
              "image": "",
              "targetText": "Break down into humus",
              "targetImage": ""
            }
          ]
        },
        {
          "question": "Match the soil type to its property.",
          "options": [
            {
              "id": "sandy",
              "text": "Sandy Soil",
              "image": "",
              "targetText": "Drains water quickly, feels gritty",
              "targetImage": ""
            },
            {
              "id": "clay",
              "text": "Clay Soil",
              "image": "",
              "targetText": "Holds water, feels sticky when wet",
              "targetImage": ""
            },
            {
              "id": "loam",
              "text": "Loam",
              "image": "",
              "targetText": "Mix of sand, silt, and clay—great for plants",
              "targetImage": ""
            },
            {
              "id": "silt",
              "text": "Silty Soil",
              "image": "",
              "targetText": "Feels smooth, holds moisture well",
              "targetImage": ""
            }
          ]
        },
        {
          "question": "Match the lyric idea to what it means.",
          "options": [
            {
              "id": "food_to_grow",
              "text": "“Soil gives roots their food to grow”",
              "image": "",
              "targetText": "Soil provides nutrients for plants",
              "targetImage": ""
            },
            {
              "id": "full_of_life",
              "text": "“It’s full of life, from worms to bugs”",
              "image": "",
              "targetText": "Many living things help the soil",
              "targetImage": ""
            },
            {
              "id": "layers_low",
              "text": "“Down below are layers low”",
              "image": "",
              "targetText": "Soil is made of different levels",
              "targetImage": ""
            },
            {
              "id": "soft_and_strong",
              "text": "“It’s soft but strong, a mighty friend”",
              "image": "",
              "targetText": "Soil supports and holds up plants",
              "targetImage": ""
            }
          ]
        }
      ]
    },
    {
      "slug": "naturalresources",
      "title": "Natural Resources",
      "gameType": "multipleChoice",
      "questions": [
        {
          "question": "What are natural resources?",
          "answers": [
            { "text": "Things we use that come from nature", "correct": true },
            { "text": "Machines built by people", "correct": false },
            { "text": "Toys and games", "correct": false },
            { "text": "Buildings and streets", "correct": false }
          ]
        },
        {
          "question": "Which of these is a natural resource?",
          "answers": [
            { "text": "Water", "correct": true },
            { "text": "Plastic", "correct": false },
            { "text": "Electric wires", "correct": false },
            { "text": "Light bulbs", "correct": false }
          ]
        },
        {
          "question": "Why do we need to take care of natural resources?",
          "answers": [
            { "text": "Because we depend on them to live", "correct": true },
            { "text": "So we can throw them away", "correct": false },
            { "text": "To make them last forever", "correct": false },
            { "text": "Because they look pretty", "correct": false }
          ]
        },
        {
          "question": "What is one way to conserve natural resources?",
          "answers": [
            { "text": "Turn off water when brushing teeth", "correct": true },
            { "text": "Use extra lights all the time", "correct": false },
            { "text": "Leave trash in rivers", "correct": false },
            { "text": "Take long showers every day", "correct": false }
          ]
        },
        {
          "question": "Which of the following is NOT a natural resource?",
          "answers": [
            { "text": "Video games", "correct": true },
            { "text": "Sunlight", "correct": false },
            { "text": "Trees", "correct": false },
            { "text": "Soil", "correct": false }
          ]
        }
      ]
    },
    {
      "slug": "reducereuserecycle",
      "title": "Reduce, Reuse, Recycle",
      "gameType": "dragDrop",
      "placeholderStyle": {
        "backgroundColor": "#b2d8ff"
      },
      "placeholderImage": "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/images%2Fbg-texture-light-blue-1.png?alt=media&token=059bb3e7-21f9-477b-ad74-fdfd02a715cc",
      "questions": [
        {
          "question": "Match the 3 R’s with their meaning.",
          "options": [
            {
              "id": "reduce",
              "text": "Reduce",
              "image": "",
              "targetText": "Use less so we don’t waste",
              "targetImage": ""
            },
            {
              "id": "reuse",
              "text": "Reuse",
              "image": "",
              "targetText": "Use something again instead of throwing it away",
              "targetImage": ""
            },
            {
              "id": "recycle",
              "text": "Recycle",
              "image": "",
              "targetText": "Make something new out of something old",
              "targetImage": ""
            },
            {
              "id": "conserve",
              "text": "Conserve",
              "image": "",
              "targetText": "Protect and save natural resources",
              "targetImage": ""
            }
          ]
        },
        {
          "question": "Match each example to the best R.",
          "options": [
            {
              "id": "turnoff",
              "text": "Turn off lights when not in use",
              "image": "",
              "targetText": "Reduce",
              "targetImage": ""
            },
            {
              "id": "donate",
              "text": "Donate old clothes",
              "image": "",
              "targetText": "Reuse",
              "targetImage": ""
            },
            {
              "id": "sorttrash",
              "text": "Put cans in recycling bin",
              "image": "",
              "targetText": "Recycle",
              "targetImage": ""
            },
            {
              "id": "collectrain",
              "text": "Collect rainwater to water plants",
              "image": "",
              "targetText": "Conserve",
              "targetImage": ""
            }
          ]
        },
        {
          "question": "Match the item to what you can do with it.",
          "options": [
            {
              "id": "plastic_bottle",
              "text": "Plastic bottle",
              "image": "",
              "targetText": "Recycle into new plastic items",
              "targetImage": ""
            },
            {
              "id": "glass_jar",
              "text": "Glass jar",
              "image": "",
              "targetText": "Reuse as a storage container",
              "targetImage": ""
            },
            {
              "id": "old_tshirt",
              "text": "Old t-shirt",
              "image": "",
              "targetText": "Reuse as a cleaning rag",
              "targetImage": ""
            },
            {
              "id": "extra_paper",
              "text": "Extra paper",
              "image": "",
              "targetText": "Recycle into new paper",
              "targetImage": ""
            }
          ]
        },
        {
          "question": "Match the lyric to the idea it supports.",
          "options": [
            {
              "id": "less_is_best",
              "text": "“Use a little less, that’s the best!”",
              "image": "",
              "targetText": "Reduce",
              "targetImage": ""
            },
            {
              "id": "used_again",
              "text": "“Use it again and again”",
              "image": "",
              "targetText": "Reuse",
              "targetImage": ""
            },
            {
              "id": "new_from_old",
              "text": "“Turn it into something new”",
              "image": "",
              "targetText": "Recycle",
              "targetImage": ""
            },
            {
              "id": "save_earth",
              "text": "“Protect our Earth and sky so blue”",
              "image": "",
              "targetText": "Conserve",
              "targetImage": ""
            }
          ]
        },
        {
          "question": "Match the action to the goal it supports.",
          "options": [
            {
              "id": "short_shower",
              "text": "Take short showers",
              "image": "",
              "targetText": "Reduce water use",
              "targetImage": ""
            },
            {
              "id": "use_bag",
              "text": "Use a cloth bag at the store",
              "image": "",
              "targetText": "Reuse instead of plastic",
              "targetImage": ""
            },
            {
              "id": "recycle_paper",
              "text": "Recycle paper and cardboard",
              "image": "",
              "targetText": "Save trees and resources",
              "targetImage": ""
            },
            {
              "id": "earth_care",
              "text": "Care for the Earth daily",
              "image": "",
              "targetText": "Conserve natural resources",
              "targetImage": ""
            }
          ]
        }
      ]
    }
  ],

  "nc_2nd_science": [
    {
      slug: "matterrock",
      title: "States of Matter",
      gameType: "multipleChoice",
      questions: [
        {
          question: "What are the three states of matter?",
          answers: [
            { text: "Solid, Liquid, Gas", correct: true },
            { text: "Rock, Paper, Scissors", correct: false },
            { text: "Earth, Wind, Fire", correct: false },
            { text: "Hot, Cold, Medium", correct: false }
          ]
        },
        {
          question: "Which state of matter has a fixed shape?",
          answers: [
            { text: "Solid", correct: true },
            { text: "Liquid", correct: false },
            { text: "Gas", correct: false },
            { text: "Plasma", correct: false }
          ]
        }
      ]
    },

    {
      slug: "animallifecycle",
      title: "Animal Life Cycle",
      gameType: "dragDrop",
      questions: [
        {
          question: "Drag the stages of life into the correct order.",
          options: [
            { text: "Birth", image: "/assets/birth.png", targetText: "Birth Label", targetImage: "/assets/birth-label.png" },
            { text: "Teenager", image: "/assets/teenager.png", targetText: "Teenager Label", targetImage: "/assets/teenager-label.png" },
            { text: "Adulthood", image: "/assets/adulthood.png", targetText: "Adulthood Label", targetImage: "/assets/adulthood-label.png" },
            { text: "Senior", image: "/assets/senior.png", targetText: "Senior Label", targetImage: "/assets/senior-label.png" }
          ]
        }
      ]
    }
  ],

  "nc_2nd_socialstudies": [
    {
      slug: "founding-fathers",
      title: "Founding Fathers",
      gameType: "matchQuiz",
      questions: [
        {
          prompt: "Match the Founding Father to their role.",
          pairs: [
            {
              left: { text: "George Washington", image: "/assets/washington.png" },
              right: { text: "First President", image: "/assets/president.png" }
            },
            {
              left: { text: "Thomas Jefferson", image: "/assets/jefferson.png" },
              right: { text: "Author of Declaration", image: "/assets/declaration.png" }
            },
            {
              left: { text: "Ben Franklin", image: "/assets/franklin.png" },
              right: { text: "Inventor", image: "/assets/inventor.png" }
            }
          ]
        }
      ]
    }
  ],
};
